module.exports = __webpack_public_path__ + "sv.4ca3940b27e5583e1ce5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sv.svg
// module chunks = styles